<ng-container [ngSwitch]="actionStatus">

  <ng-container *ngSwitchCase="actionStatusEnum.Select">
    <button mat-stroked-button
            color="primary"
            class="action"
            *ngIf="this.isOfferSelectable"
            (click)="onClickSelectOffer()">
      Select this offer
    </button>
  </ng-container>

  <ng-container *ngSwitchCase="actionStatusEnum.Selecting">
    <button mat-stroked-button
            color="primary"
            class="action action--selecting">
      <span class="loader-1"></span>
      Please wait...
    </button>
  </ng-container>

  <ng-container *ngSwitchCase="actionStatusEnum.Selected">
    <button mat-stroked-button
            color="primary"
            class="action action--selected">
      <mat-icon>check_circle</mat-icon>
      Selected
    </button>
  </ng-container>
</ng-container>
